import withTheme from '@material-ui/core/styles/withTheme';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const SelectPrintMethodModal = ({ showModal, MODAL_TYPE, printUrl }) => {
    return (
        <Dialog
            open
            onClose={() => showModal(MODAL_TYPE.NONE)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Print your voucher</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Please select how you want to print your voucher!
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    size="small"
                    variant="contained"
                    href={`${printUrl}?print&price=true`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => showModal(MODAL_TYPE.NONE)}
                >
                    Print with price
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    href={`${printUrl}?print&price=false`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => showModal(MODAL_TYPE.NONE)}
                >
                    Print without price
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withTheme(SelectPrintMethodModal);
